//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { mapState } from 'vuex'
    import ImageSrcsetMixin from '~/mixins/ImageSrcsetMixin';
    import userChecks from '~/mixins/userChecks';
    import { formatDate, convertDuration } from '@/helpers/filters.js'
    export default {
        mixins: [userChecks, ImageSrcsetMixin],
        async fetch() {
          this.$store.commit('mxmStore/clearStream');

          const resource = await this.$store.dispatch('resourcesStore/getResource', {
            slug: this.$route.params.slug,
            query: this.queries.privatevideo,
            checkAccess: this.$auth.loggedIn
        });

          const resourceId = resource.id;

          if (this.$auth.loggedIn && resource.product === 'paid' && resource.status === 'published') {
            await this.$store.dispatch('resourcesStore/checkResourceAccess', {
              id: resourceId,
              type: this.queries.privatevideo.content
          });
        } else if (resource.product === 'free') {
            this.$store.commit('resourcesStore/setAccess', {
              access: true,
              subscription: [],
              type: 'privatevideo'
          });
        }
        await Promise.all([ 
            this.$store.dispatch('bannerStore/getBanner', 'resource'),
            this.$store.dispatch('resourcesStore/countResource', {
                id: this.$route.params.slug
            })
        ])
    },
    head() {
        return {
            title: this.privatevideo && this.privatevideo.seo && this.privatevideo.seo ? this.privatevideo.seo.title : ' | Privéfilmpjes | ' + process.env.APP_TITLE,
            meta: [
                { hid: 'title', name: 'title', content: this.privatevideo && this.privatevideo.seo && this.privatevideo.seo ? this.privatevideo.seo.title : ' Privéfilmpje | ' + process.env.APP_TITLE},
                { hid: 'og:title', name: 'og:title', content: this.privatevideo && this.privatevideo.seo && this.privatevideo.seo ? this.privatevideo.seo.title : ' Privéfilmpje | ' + process.env.APP_TITLE},
                { hid: 'twitter:title', name: 'twitter:title', content: this.privatevideo && this.privatevideo.seo && this.privatevideo.seo ? this.privatevideo.seo.title : ' Privéfilmpje | ' + process.env.APP_TITLE},
                { hid: 'description', name: 'description', content: this.privatevideo && this.privatevideo.seo && this.privatevideo.seo ? this.privatevideo.seo.description : 'Geil Privéfilmpje van Meiden van Holland'},
                { hid: 'og:description', name: 'og:description', content: this.privatevideo && this.privatevideo.seo && this.privatevideo.seo ? this.privatevideo.seo.description : 'Geil Privéfilmpje van Meiden van Holland'},
                { hid: 'twitter:description', name: 'twitter:description', content: this.privatevideo && this.privatevideo.seo && this.privatevideo.seo ? this.privatevideo.seo.description : 'Geil Privéfilmpje van Meiden van Holland'},
                { hid: 'og:url', name: 'og:url', content: this.privatevideo && this.privatevideo.slug ? 'https://meidenvanholland.nl/privefilmpjes/' + this.privatevideo.slug : 'https://meidenvanholland.nl/privefilmpjes/'},
                    { hid: 'twitter:url', name: 'twitter:url', content: this.privatevideo && this.privatevideo.slug ? 'https://meidenvanholland.nl/privefilmpjes/' + this.privatevideo.slug : 'https://meidenvanholland.nl/privefilmpjes/'},
                        { hid: 'keywords', name: 'keywords', content: this.privatevideo && this.privatevideo.seo && this.privatevideo.seo ? this.privatevideo.seo.keywords : 'prive, privefilmpjes, pornoster, Meiden van Holland'},
                        { hid: 'og:image', name: 'og:image', content: this.privatevideo && this.privatevideo.images && this.privatevideo.images[0] ? process.env.CDN + this.privatevideo.images[0].sizes.l : ''},
                        { hid: 'twitter:image', name: 'twitter:image', content: this.privatevideo && this.privatevideo.images && this.privatevideo.images[0] ? process.env.CDN + this.privatevideo.images[0].sizes.l : ''},
                        { hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image'},
                    ],
                }
            },
            components: {
                dummy: () => import('~/components/content/dummy/resource_dummy.vue'),
                thumb: () => import('~/components/thumb'),
                breadcrumbs: () => import('~/components/breadcrumbs'),
                banner: () => import('~/components/banner.vue'),
                maxXsPlayer: () => import('~/components/maxxXsPlayer'),
                getAccess: () => import('~/components/get_access'),
                dateviews: () => import('~/components/date_views'),
                RelatedResources: () => import('~/components/RelatedResources'),
                Paywall: () => import('~/components/payment/module.vue'),
                error: () => import('~/components/error.vue')
            },
            computed: {
                ...mapState({
                    queries: ({ resourcesStore: {queries} }) => queries,
                    privatevideo: ({ resourcesStore: {privatevideo} }) => privatevideo,
                    playerState: ({ mxmStore: {playerState} }) => playerState,
                    killStream: ({ mxmStore: {killStream} }) => killStream,
                    playerState: ({ mxmStore: {playerState} }) => playerState,
                    stream: ({ mxmStore: {stream} }) => stream,
                    ppmStatus: ({ ppmStore: { ppmStatus } }) => ppmStatus,
                    modal: ({ modalStore: {modal} }) => modal,
                    loading: ({ resourcesStore: {loading} }) => loading,
                    access: ({ resourcesStore: {access} }) => access
                }),
                choosePlaybutton(){
                    if(
                        this.playerState.type == 'film' && 
                        this.access.access && 
                        this.playerState.status != 'exit' && 
                        this.playerState.status != 'pause' && 
                        this.privatevideo.videos.data.film && 
                        this.privatevideo.videos.data.film[0].id || 
                        !this.playerState.type && 
                        this.access.access && 
                        this.playerState.status != 'exit'&& 
                        this.playerState.status != 'pause' && 
                        this.privatevideo.videos.data.film && 
                        this.privatevideo.videos.data.film[0].id
                        ) {
                        return 'paidFilm';
                } else if (
                    this.playerState.type == 'film' && 
                    this.access.access && 
                    this.playerState.status != 'exit' && 
                    !this.privatevideo.videos.data.film && 
                    this.privatevideo.videos.data.free_film && 
                    this.privatevideo.videos.data.free_film[0].id || 
                    !this.playerState.type && 
                    this.access.access && 
                    this.playerState.status != 'exit' && 
                    !this.privatevideo.videos.data.film && 
                    this.privatevideo.videos.data.free_film && 
                    this.privatevideo.videos.data.free_film[0].id) 
                {
                    return 'freeFilm';
                }
            }
        },
        watch: {
            access: function() {
                this.$auth.fetchUser();
                this.checkPaywall();
                console.log('access has changed so refresh the user');
            },
            preroll: function(newValue, oldValue) {
                if (newValue === 'shown') {
                    this.loadFreeFilm(this.privatevideo.videos.data.free_film[0].id);
                }
            },
            stream: function() {
                if (this.stream.location == 'sexfilm' && this.stream.ITEM && this.stream.ITEM.LINKS) {
                    if (this.privatevideo.images && this.privatevideo.images.data && this.privatevideo.images.data.thumb && this.privatevideo.images.data.thumb[0]) {
                        var thumb = this.$config.cdn + this.privatevideo.images.data.thumb[0].path
                    } else {
                        var thumb = this.$config.cdn + this.$config.errorimg;
                    }
                    let playerOptions = {
                        autoplay: true,
                        poster: thumb
                    }
                    this.$store.commit('mxmStore/updatePlayerOptions', playerOptions);
                    this.$store.commit('mxmStore/setPlayerType', this.stream.type);

                    var phone_stream_id = this.getCookie('phone_stream_id');
                    if (phone_stream_id) {
                // PPM access so we should check status with interval
                // Interval is handled by mxmStore
                        var dataObj = {
                            action: 'update',
                            stream_id: phone_stream_id
                        }; 
                        this.$store.dispatch('mxmStore/startUpdateStream', dataObj);
                    }
                }
            },
            killStream: function() {
                var phone_stream_id = this.getCookie('phone_stream_id');
                if (this.killStream == true && phone_stream_id) {
                  this.doKillStream('phone');
              }
          },
          privatevideo: function() {
            this.checkPaywall();
            var phone_stream_id = this.getCookie('phone_stream_id');
            if (phone_stream_id) {
                this.$store.dispatch('ppmStore/checkPhoneStreamStatus', phone_stream_id);
            }
        }
    },
    methods: {
        formatDate,
        convertDuration,
        checkPaywall() {
            if (this.$route.params.slug != this.privatevideo.slug) {
                return;
            }
            if (!this.access.access && !this.ppmStatus.action && window.innerWidth < 1200) {
                this.$store.commit('paywallStore/setView', 'active');
                this.$store.commit('paywallStore/setStep', 0);
            } else {
                this.$store.commit('paywallStore/setView', 'closed');
            }
        },
        loadPaidFilm(videoId) {
            this.$store.commit('mxmStore/clearStream');
            this.kind = false;
            if (this.stream && this.stream.id && this.stream.type == 'film') {
                return this.$store.commit('mxmStore/setPlayerStatus', 'playing')
            }
            var dataObj = {
                video_id: videoId,
                resource_id: this.privatevideo.id,
                type: 'film',
                location: 'sexfilm',
                product_type: 'paid'
            };
            if (this.$store.state.auth.loggedIn) {
                dataObj.user_id = this.$store.state.auth.user.id;
            }

            var phone_stream_id = this.getCookie('phone_stream_id');
            if (phone_stream_id) {
                dataObj.phone_stream_id = phone_stream_id;
                dataObj.subscription_id = 3;
                return this.$store.dispatch('mxmStore/getStream', dataObj)
            } else {
                dataObj.subscription_id = this.access.subscription.id ? this.access.subscription.id : 1;
                return this.$store.dispatch('mxmStore/getStream', dataObj)
            }
        },
    }
}
